export const SITE = {
  name: "Le dolci Dimore",
  legalName: "Carmadue9 Srl",
  tagline: "B&B in una villa del Settecento, a dieci minuti da Mantova",
  address: "Strada Romana 69/A",
  city: "Borgo Virgilio (MN)",
  cap: "46034",
  phone: "+39 0376 1587002",
  phoneHref: "tel:+3903761587002",
  email: "info@ledolcidimore.it",
  emailHref: "mailto:info@ledolcidimore.it",
  whatsapp: "+39 0376 1587002",
  whatsappHref: "https://wa.me/3903761587002",
  url: "https://ledolcidimore.it",
  bookingUrl: "https://ledolcidimore.beddy.io?lang=it",
  mapsEmbed:
    "https://www.google.com/maps?q=Strada+Romana+69%2FA%2C+46034+Borgo+Virgilio+MN&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Strada+Romana+69%2FA%2C+46034+Borgo+Virgilio+MN",
};

export const IMAGES = {
  villaHero: "/images/villa-dal-giardino-le-dolci-dimore.jpg",
  facade: "/images/facciata-villa-settecentesca-le-dolci-dimore.jpg",
  facadeSide: "/images/facciata-laterale-villa-le-dolci-dimore.jpg",
  gardenSeating: "/images/giardino-sedute-le-dolci-dimore.jpg",
  garden: "/images/giardino-le-dolci-dimore.jpg",
  reception: "/images/area-comune-reception-le-dolci-dimore.jpg",
  facadeDoor: "/images/facciata-laterale-villa-le-dolci-dimore.jpg",
  hero: "https://images.unsplash.com/photo-1652677447709-51228eb8b3b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxoaXN0b3JpYyUyMGl0YWxpYW4lMjB2aWxsYSUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MzIwMzg2M3ww&ixlib=rb-4.1.0&q=85",
  villa: "https://images.unsplash.com/photo-1696952196212-d2acb88ea1c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwY291bnRyeSUyMHZpbGxhJTIwZ2FyZGVufGVufDB8fHx8MTc5MzIwNDA0MHww&ixlib=rb-4.1.0&q=85",
  roomInterior: "https://images.unsplash.com/photo-1731336478850-6bce7235e320?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwYm91dGlxdWUlMjBob3RlbCUyMHJvb20lMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTMyMDM4NjN8MA&ixlib=rb-4.1.0&q=85",
  standard1: "https://images.unsplash.com/photo-1598928636135-d146006ff4be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwbmV1dHJhbCUyMGJlZHJvb20lMjBuYXR1cmFsJTIwbGlnaHR8ZW58MHx8fHwxNzkzMjA0MDQwfDA&ixlib=rb-4.1.0&q=85",
  standard2: "https://images.unsplash.com/photo-1766431014990-39bb54f64f50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHx3YXJtJTIwbGluZW4lMjBkb3VibGUlMjBiZWRyb29tfGVufDB8fHx8MTc5MzIwNDA0MHww&ixlib=rb-4.1.0&q=85",
  superior: "https://images.unsplash.com/photo-1612152605347-f93296cb657d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxsYXJnZSUyMGJlZHJvb20lMjB3aXRoJTIwc29mYXxlbnwwfHx8fDE3OTMyMDQwNDl8MA&ixlib=rb-4.1.0&q=85",
  deluxe: "https://images.unsplash.com/photo-1736386346432-71a243bf8636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxsYXJnZSUyMGZhbWlseSUyMGJlZHJvb20lMjBjb3VjaHxlbnwwfHx8MTc5MzIwNDA0OXww&ixlib=rb-4.1.0&q=85",
  linen: "https://images.unsplash.com/photo-1588610992315-5654831ceebd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxiZWQlMjBsaW5lbiUyMGNsb3NlJTIwdXAlMjBkZXRhaWx8ZW58MHx8fHwxNzkzMjA0MDQwfDA&ixlib=rb-4.1.0&q=85",
  bathroom: "https://images.unsplash.com/photo-1552143232-454554411763?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwYmF0aHJvb20lMjBkZXRhaWwlMjB3b29kfGVufDB8fHx8MTc5MzIwNDA0MHww&ixlib=rb-4.1.0&q=85",
  breakfast: "/images/colazione-in-camera-le-dolci-dimore.jpg",
  garden: "https://images.unsplash.com/photo-1759062012138-70f215751ca7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwY291bnRyeSUyMGdhcmRlbiUyMGxhd24lMjB0cmVlc3xlbnwwfHx8MTc5MzIwNDA0MHww&ixlib=rb-4.1.0&q=85",
  gazebo: "https://images.unsplash.com/photo-1533554030380-20991a0f9c9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxoaXN0b3JpYyUyMGl0YWxpYW4lMjB2aWxsYSUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MzIwMzg2M3ww&ixlib=rb-4.1.0&q=85",
  commonArea: "https://images.unsplash.com/photo-1726090401458-7abb00f7450c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxjb3p5JTIwc2hhcmVkJTIwbG91bmdlJTIwaGlzdG9yaWMlMjBob3VzZXxlbnwwfHx8MTc5MzIwNDA0MHww&ixlib=rb-4.1.0&q=85",
  mantova: "/images/mantova-lago-superiore-skyline.jpg",
  palazzoDucale: "/images/mantova-piazza-sordello-palazzo-ducale.jpg",
  palazzoTe: "https://images.unsplash.com/photo-1683117505761-244a75208b41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxwYWxhenpvJTIwdGUlMjBtYW50b3ZhfGVufDB8fHx8MTc5MzIwNDA0OXww&ixlib=rb-4.1.0&q=85",
  fresco: "https://images.unsplash.com/photo-1683117577129-9d02caf25dc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxwYWxhenpvJTIwdGUlMjBtYW50b3ZhfGVufDB8fHx8MTc5MzIwNDA0OXww&ixlib=rb-4.1.0&q=85",
  mincio: "/images/fiori-di-loto-mincio-mantova.jpg",
  cycling: "https://images.unsplash.com/photo-1788177652875-d13a9bfee562?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjBjeWNsaW5nJTIwY291bnRyeSUyMHBhdGh8ZW58MHx8fHwxNzkzMjA0MDQ5fDA&ixlib=rb-4.1.0&q=85",
  food: "/images/tortelli-di-zucca-mantovani.jpg",
  borgo: "https://images.unsplash.com/photo-1650317112510-3a97e0ae1287?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMGl0YWxpYW4lMjBoaXN0b3JpYyUyMHZpbGxhZ2UlMjBzdHJlZXR8ZW58MHx8fHwxNzkzMjA0MDQ5fDA&ixlib=rb-4.1.0&q=85",
  countryside: "https://images.unsplash.com/photo-1783545172139-ed1239282e89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwY291bnRyeXNpZGUlMjBnb2xkZW4lMjBob3VyJTIwZmllbGRzfGVufDB8fHx8MTc5MzIwNDA0OXww&ixlib=rb-4.1.0&q=85",
  business: "https://images.unsplash.com/photo-1714859100472-278ecee5abc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxsYXB0b3AlMjBvbiUyMGRlc2slMjBlbGVnYW50JTIwcm9vbXxlbnwwfHx8MTc5MzIwNDA0MHww&ixlib=rb-4.1.0&q=85",
};

const roomServices = [
  "Bagno privato in camera",
  "Bollitore e macchina per il caffè",
  "Frigorifero con acqua, succo e yogurt",
  "Prodotti per la colazione in camera",
];

export const ROOMS = [
  {
    slug: "camera-101",
    name: "Camera 101",
    type: "Camera doppia standard",
    capacity: 2,
    beds: "1 letto matrimoniale",
    idealFor: "Coppie e viaggiatori singoli",
    image: "/images/camera-101-standard-le-dolci-dimore.jpg",
    imageAlt: "Camera 101 de Le dolci Dimore: letto matrimoniale con stampe botaniche e parquet",
    gallery: [
      "/images/camera-101-standard-le-dolci-dimore.jpg",
      "/images/camera-101-dettaglio-letto-le-dolci-dimore.jpg",
      "/images/bagno-camera-101-le-dolci-dimore.jpg",
    ],
    excerpt:
      "Una camera matrimoniale essenziale e luminosa, pensata per chi cerca un punto d'appoggio curato a due passi da Mantova.",
    description: [
      "La Camera 101 è una matrimoniale accogliente al primo piano della villa. Gli spazi sono misurati e ordinati: un letto matrimoniale, il parquet, le stampe botaniche sopra la testata e un bagno privato con doccia, riservato alla camera.",
      "È la scelta più semplice per una coppia che visita Mantova e il suo territorio, ma è disponibile anche in occupazione singola per chi viaggia da solo, per turismo o per lavoro.",
      "In camera trovi tutto il necessario per iniziare la giornata in autonomia: bollitore, macchina per il caffè e prodotti per la colazione, con acqua, succo e yogurt nel frigorifero.",
    ],
    services: [
      "Bagno privato con doccia",
      "Bollitore e macchina per il caffè",
      "Frigorifero con acqua, succo e yogurt",
      "Prodotti per la colazione in camera",
    ],
  },
  {
    slug: "camera-102",
    name: "Camera 102",
    type: "Camera superior",
    capacity: 3,
    beds: "1 letto matrimoniale + divano letto singolo",
    idealFor: "Coppie con un bambino o piccoli gruppi di tre",
    image: "/images/camera-102-superior-le-dolci-dimore.jpg",
    imageAlt: "Camera 102 de Le dolci Dimore: letto matrimoniale, tavolino e postazione colazione",
    gallery: [
      "/images/camera-102-divano-letto-le-dolci-dimore.jpg",
      "/images/camera-102-zona-giorno-le-dolci-dimore.jpg",
      "/images/bagno-camera-102-le-dolci-dimore.jpg",
    ],
    excerpt:
      "Più spazio e un divano letto singolo: la soluzione giusta per chi viaggia in tre senza rinunciare alla comodità.",
    description: [
      "La Camera 102 aggiunge al letto matrimoniale un divano letto singolo di tipo click-clack, portando la capienza a tre persone. È la scelta naturale per una coppia con un bambino o per tre adulti che condividono il viaggio.",
      "Lo spazio in più si sente: il tavolino rotondo con le sedie per la colazione in camera, la scrivania e la postazione con bollitore e macchina per il caffè. Il bagno privato ha la doccia.",
      "La camera si trova al primo piano della villa e guarda sulla quiete della campagna di Borgo Virgilio.",
    ],
    services: [
      "Bagno privato con doccia",
      "Tavolino con sedie per la colazione in camera",
      "Bollitore e macchina per il caffè",
      "Frigorifero con acqua, succo e yogurt",
      "Prodotti per la colazione in camera",
    ],
  },
  {
    slug: "camera-103",
    name: "Camera 103",
    type: "Camera deluxe",
    capacity: 4,
    beds: "1 letto matrimoniale + divano letto matrimoniale",
    idealFor: "Famiglie e gruppi fino a quattro persone",
    image: "/images/camera-103-deluxe-le-dolci-dimore.jpg",
    imageAlt: "Camera 103 de Le dolci Dimore: letto matrimoniale, divano letto e tavolino per la colazione",
    gallery: [
      "/images/camera-103-deluxe-le-dolci-dimore.jpg",
      "/images/camera-103-divano-letto-le-dolci-dimore.jpg",
      "/images/bagno-camera-103-le-dolci-dimore.jpg",
    ],
    excerpt:
      "La camera più grande della villa: matrimoniale più divano letto matrimoniale, per famiglie e piccoli gruppi fino a quattro ospiti.",
    description: [
      "La Camera 103 è la più ampia de Le dolci Dimore: al letto matrimoniale affianca un divano letto matrimoniale, per un totale di quattro posti letto. È la risposta per le famiglie con due figli o per due coppie di amici che vogliono condividere la stessa camera.",
      "Il pavimento in parquet, il tavolino rotondo con le sedie per la colazione in camera e le luci calde la rendono uno spazio comodo da vivere, non solo per dormire. Il bagno privato, ampio e piastrellato, ha doppio lavabo, doccia e vasca.",
      "Al primo piano della villa, con il kit colazione in camera e il frigorifero rifornito di acqua, succo e yogurt.",
    ],
    services: [
      "Bagno privato con doppio lavabo, doccia e vasca",
      "Tavolino con sedie per la colazione in camera",
      "Bollitore e macchina per il caffè",
      "Frigorifero con acqua, succo e yogurt",
      "Prodotti per la colazione in camera",
    ],
  },
  {
    slug: "camera-104",
    name: "Camera 104",
    type: "Camera doppia standard",
    capacity: 2,
    beds: "1 letto matrimoniale",
    idealFor: "Coppie e viaggiatori singoli",
    image: "/images/camera-104-standard-le-dolci-dimore.jpg",
    imageAlt: "Camera 104 de Le dolci Dimore: letto matrimoniale e tavolino per la colazione",
    gallery: [
      "/images/camera-104-vista-le-dolci-dimore.jpg",
      "/images/camera-104-letto-le-dolci-dimore.jpg",
      "/images/bagno-camera-104-le-dolci-dimore.jpg",
    ],
    excerpt:
      "La seconda matrimoniale della casa: stessa cura, stesso bagno privato, un'atmosfera raccolta per dormire bene nella quiete della campagna.",
    description: [
      "La Camera 104 condivide con la 101 la stessa filosofia: una matrimoniale ordinata e tranquilla al primo piano, con bagno privato con doccia.",
      "È pensata per due persone, con la possibilità di occupazione singola. Il parquet, il tavolino rotondo con le sedie per la colazione in camera e le luci calde la rendono raccolta e comoda. Di sera la campagna intorno alla villa garantisce un silenzio raro per chi è abituato a dormire in città.",
      "Come in ogni camera de Le dolci Dimore, la colazione si organizza in autonomia: croissant, fette biscottate, marmellate e Nutella, bollitore e macchina per il caffè, e un frigorifero con acqua, succo e yogurt.",
    ],
    services: [
      "Bagno privato con doccia",
      "Tavolino con sedie per la colazione in camera",
      "Bollitore e macchina per il caffè",
      "Frigorifero con acqua, succo e yogurt",
      "Prodotti per la colazione in camera",
    ],
  },
];

export const SERVICES = [
  {
    title: "Bagno privato in ogni camera",
    text: "Tutte e quattro le camere hanno il proprio bagno privato: nessuna condivisione con altri ospiti.",
    icon: "bath",
  },
  {
    title: "Giardino",
    text: "Un ampio giardino circonda la villa: spazio per leggere, respirare e stare all'aperto nella quiete della campagna.",
    icon: "trees",
  },
  {
    title: "Area comune interna",
    text: "Uno spazio condiviso all'interno della villa, a disposizione degli ospiti per un momento di pausa.",
    icon: "armchair",
  },
  {
    title: "Assistenza telefonica",
    text: "Per l'arrivo e per tutta la durata del soggiorno restiamo raggiungibili al telefono.",
    icon: "phone",
  },
  {
    title: "Colazione semplice in camera",
    text: "Croissant, fette biscottate, cereali, biscotti, miele, marmellate e Nutella; in frigorifero acqua, succo e yogurt. Bollitore e macchina per il caffè a disposizione.",
    icon: "coffee",
  },
  {
    title: "Check-in flessibile assistito",
    text: "Accoglienza di persona quando possibile; in alternativa, accesso da remoto organizzato con assistenza telefonica.",
    icon: "key-round",
  },
];

export const PRACTICAL_INFO = [
  { label: "Check-in", value: "dalle 15:00 alle 20:00" },
  { label: "Check-out", value: "entro le 10:00" },
  { label: "Colazione", value: "in camera, al tuo ritmo" },
  { label: "Riordino camere", value: "camere rinfrescate ogni giorno entro mezzogiorno" },
  { label: "Accesso", value: "di persona o da remoto, con assistenza telefonica" },
  { label: "Posizione camere", value: "primo piano della villa" },
];

export const TERRITORY = [
  {
    id: "mantova",
    title: "Mantova e il centro storico",
    intro:
      "Mantova è una città d'arte racchiusa tra tre laghi, Patrimonio UNESCO insieme a Sabbioneta. Il suo centro storico si visita a piedi, tra piazze lastricate, portici e palazzi rinascimentali.",
    places: [
      {
        name: "Piazza Sordello e il Duomo",
        why: "Il cuore medievale della città: una delle piazze più grandi e suggestive d'Italia, con il Duomo, Palazzo Bonacolsi e l'ingresso monumentale di Palazzo Ducale.",
        distance: "circa 10 minuti in auto",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
      {
        name: "Piazza delle Erbe e la Rotonda di San Lorenzo",
        why: "La piazza del mercato, con i portici, la Torre dell'Orologio e la Rotonda di San Lorenzo, la chiesa più antica di Mantova, di ispirazione romanica.",
        distance: "circa 10 minuti in auto",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
      {
        name: "Basilica di Sant'Andrea",
        why: "Capolavoro rinascimentale di Leon Battista Alberti, custodisce la reliquia dei Preziosissimi Vasi e affreschi legati al Mantegna.",
        distance: "circa 10 minuti in auto",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
    ],
  },
  {
    id: "gonzaga",
    title: "I Gonzaga: Palazzo Ducale e Palazzo Te",
    intro:
      "Per tre secoli i Gonzaga hanno reso Mantova una delle capitali del Rinascimento. I loro palazzi raccontano questa storia meglio di qualsiasi libro.",
    places: [
      {
        name: "Palazzo Ducale e Castello di San Giorgio",
        why: "Una città nella città: oltre 500 stanze, cortili e giardini. Nel Castello di San Giorgio si trova la Camera degli Sposi, il capolavoro di Andrea Mantegna.",
        distance: "circa 10 minuti in auto",
        link: "https://www.palazzoducalemantova.it/",
        linkLabel: "Sito ufficiale",
      },
      {
        name: "Palazzo Te",
        why: "La villa di svago voluta da Federico II Gonzaga e progettata da Giulio Romano: la Camera dei Giganti e quella di Amore e Psiche sono tra gli affreschi più celebri del Manierismo.",
        distance: "circa 10 minuti in auto",
        link: "https://www.palazzote.it/",
        linkLabel: "Sito ufficiale",
      },
    ],
  },
  {
    id: "mincio",
    title: "Laghi di Mantova e Parco del Mincio",
    intro:
      "Mantova sorge su una penisola tra i laghi formati dal fiume Mincio. Il Parco del Mincio protegge un paesaggio d'acqua unico, famoso per la fioritura estiva dei fiori di loto.",
    places: [
      {
        name: "I laghi e lo skyline di Mantova",
        why: "Il profilo della città visto dall'acqua è una delle immagini più belle della Lombardia, soprattutto al tramonto, dal ponte di San Giorgio o da Sparafucile.",
        distance: "circa 10-15 minuti in auto",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
      {
        name: "Navigazione sul Mincio e fiori di loto",
        why: "Tra luglio e agosto le distese di fiori di loto trasformano le acque del Mincio. I motonavi partono da Mantova e da Grazie per escursioni nella riserva.",
        distance: "imbarco a circa 15-20 minuti in auto",
        link: "https://www.parcodelmincio.it/",
        linkLabel: "Parco del Mincio",
      },
    ],
  },
  {
    id: "natura",
    title: "Natura, passeggiate e percorsi ciclabili",
    intro:
      "La pianura intorno a Mantova è attraversata da piste ciclabili sicure e panoramiche, che corrono lungo gli argini dei fiumi e i canali.",
    places: [
      {
        name: "Ciclabile Mantova – Peschiera del Garda",
        why: "Circa 45 km di pista quasi interamente protetta che dal Lago Superiore di Mantova risale il Mincio fino a Peschiera, tra campagne, borghi e scorci sul fiume.",
        distance: "accesso al percorso a circa 15 minuti in auto",
        link: "https://www.parcodelmincio.it/",
        linkLabel: "Parco del Mincio",
      },
      {
        name: "Passeggiate lungo gli argini",
        why: "Itinerari semplici a piedi o in bicicletta lungo il Mincio e i corsi d'acqua della bassa, adatti a tutti, anche con bambini.",
        distance: "nei dintorni della struttura",
        link: "https://www.parcodelmincio.it/",
        linkLabel: "Parco del Mincio",
      },
    ],
  },
  {
    id: "borghi",
    title: "Borghi e località della provincia",
    intro:
      "La provincia mantovana è costellata di borghi che vale la pena scoprire con calma, alternandoli alle visite in città.",
    places: [
      {
        name: "Grazie di Curtatone",
        why: "Piccolo borgo sul Mincio con il Santuario delle Beata Vergine, celebre per i madonnari e la Fiera dell'Assunta del 15 agosto.",
        distance: "circa 15-20 minuti in auto",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
      {
        name: "Sabbioneta",
        why: "La “città ideale” rinascimentale fondata da Vespasiano Gonzaga: cinta muraria, Teatro all'Antica e Palazzo Giardino. Patrimonio UNESCO insieme a Mantova.",
        distance: "circa 35-40 minuti in auto",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
      {
        name: "San Benedetto Po",
        why: "Sede della grande abbazia benedettina di Polirone, uno dei complessi monastici più importanti d'Italia, legato alla figura di Matilde di Canossa.",
        distance: "circa 25-30 minuti in auto",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
      {
        name: "Castellaro Lagusello e Borghetto sul Mincio",
        why: "Due tra i borghi più fotografati d'Italia: il primo affacciato su un laghetto morenico, il secondo tra i mulini e i ponti viscontei di Valeggio.",
        distance: "circa 40-45 minuti in auto",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
    ],
  },
  {
    id: "cucina",
    title: "Cucina mantovana e prodotti tipici",
    intro:
      "La tavola mantovana è una ragione di viaggio in sé: una cucina di corte e di campagna, fatta di pasta ripiena, riso, salumi e dolci antichi.",
    places: [
      {
        name: "Tortelli di zucca",
        why: "Il piatto simbolo: pasta fresca ripiena di zucca, mostarda e amaretti, servita con burro fuso e salvia. Da provare almeno una volta.",
        distance: "trattorie e ristoranti a pochi minuti dalla struttura",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
      {
        name: "Risotto alla pilota, sbrisolona e salame mantovano",
        why: "Il riso “alla pilota” con la puntel, la torta sbrisolona da rompere con le mani e il salame morbido della bassa: la trilogia della tradizione contadina.",
        distance: "trattorie e ristoranti a pochi minuti dalla struttura",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
    ],
  },
  {
    id: "eventi",
    title: "Eventi e appuntamenti stagionali",
    intro:
      "Il territorio vive di appuntamenti che si ripetono ogni anno e che da soli valgono un soggiorno.",
    places: [
      {
        name: "Festivaletteratura",
        why: "A settembre, per cinque giorni, Mantova ospita uno dei festival letterari più importanti d'Europa: incontri, letture e spettacoli in ogni piazza e cortile.",
        distance: "centro di Mantova, circa 10 minuti in auto",
        link: "https://www.festivaletteratura.it/",
        linkLabel: "Sito ufficiale",
      },
      {
        name: "Fioritura dei fiori di loto",
        why: "Tra luglio e agosto i fiori di loto colorano le acque del Mincio: uno spettacolo naturale unico in Italia, da vedere al mattino presto o al tramonto.",
        distance: "zona Grazie di Curtatone, circa 15-20 minuti in auto",
        link: "https://www.parcodelmincio.it/",
        linkLabel: "Parco del Mincio",
      },
      {
        name: "Fiera dell'Assunta a Grazie",
        why: "Ogni 15 agosto il sagrato del Santuario delle Grazie si riempie di gessi colorati: i madonnari di tutto il mondo disegnano per una notte intera.",
        distance: "circa 15-20 minuti in auto",
        link: "https://www.turismo.mantova.it/",
        linkLabel: "Turismo Mantova",
      },
    ],
  },
  {
    id: "dintorni",
    title: "Mete raggiungibili nei dintorni",
    intro:
      "Le dolci Dimore è una base comoda anche per esplorare le città e i paesaggi oltre la provincia, in giornata.",
    places: [
      {
        name: "Verona",
        why: "L'Arena, il balcone di Giulietta, le piazze e l'Adige: una delle città più belle del Nord Italia, comoda per una gita di un giorno.",
        distance: "circa 45 minuti in auto",
        link: "https://www.visitverona.it/",
        linkLabel: "Sito ufficiale",
      },
      {
        name: "Lago di Garda",
        why: "Peschiera, Sirmione e le rive meridionali del Garda sono a meno di un'ora: passeggiate lungolago, borghi e cantine delle colline moreniche.",
        distance: "circa 45 minuti in auto",
        link: "https://www.visitgarda.com/",
        linkLabel: "Visit Garda",
      },
    ],
  },
];

export const ARTICLES = [
  {
    slug: "cosa-vedere-a-mantova-in-un-giorno",
    title: "Cosa vedere a Mantova in un giorno",
    excerpt:
      "Ventiquattr'ore nella città dei Gonzaga: un itinerario a piedi tra Palazzo Ducale, le piazze del centro e il tramonto sui laghi.",
    image: IMAGES.mantova,
    date: "Luglio 2026",
    readTime: "6 min",
    content: [
      {
        type: "p",
        text: "Mantova si visita bene in un giorno perché il suo centro storico è compatto e quasi interamente pedonale. La base ideale è fuori dal traffico: dormendo a Borgo Virgilio, a Le dolci Dimore, raggiungi il centro in circa dieci minuti in auto e la sera torni nella quiete della campagna.",
      },
      { type: "h2", text: "La mattina: Palazzo Ducale e la Camera degli Sposi" },
      {
        type: "p",
        text: "Inizia da Piazza Sordello, il cuore medievale della città. Dedica la mattina a Palazzo Ducale, la reggia dei Gonzaga: un complesso enorme di cortili, sale affrescate e giardini pensili. La tappa irrinunciabile è la Camera degli Sposi nel Castello di San Giorgio, dipinta da Andrea Mantegna: conviene prenotare l'ingresso in anticipo sul sito ufficiale, perché gli accessi sono contingentati.",
      },
      { type: "h2", text: "Il pomeriggio: piazze, portici e Sant'Andrea" },
      {
        type: "p",
        text: "Dopo pranzo in una trattoria del centro — è l'occasione per i tortelli di zucca — passeggia verso Piazza delle Erbe, con la Torre dell'Orologio e la Rotonda di San Lorenzo, la chiesa più antica della città. Da lì, pochi passi portano alla Basilica di Sant'Andrea, progettata da Leon Battista Alberti: l'interno a navata unica è uno degli spazi sacri più imponenti del Rinascimento.",
      },
      { type: "h2", text: "Se avanza tempo: Palazzo Te" },
      {
        type: "p",
        text: "Se la giornata lo consente, Palazzo Te merita la deviazione: la villa di Federico II Gonzaga, affrescata da Giulio Romano, con la celebre Camera dei Giganti. Dal centro si raggiunge a piedi in circa quindici minuti o in pochi minuti in auto.",
      },
      { type: "h2", text: "La sera: il tramonto sui laghi" },
      {
        type: "p",
        text: "Chiudi la giornata sulle rive del Lago di Mezzo o dal ponte di San Giorgio: il profilo di Mantova riflesso sull'acqua al tramonto è l'immagine che ti porterai a casa. Poi il ritorno a Le dolci Dimore, a pochi minuti, lontano dal parcheggio e dal rumore.",
      },
    ],
  },
  {
    slug: "weekend-a-mantova-itinerario",
    title: "Cosa fare a Mantova in un weekend",
    excerpt:
      "Due giorni tra arte, natura e tavola: il centro storico il sabato, il Mincio e i borghi la domenica.",
    image: IMAGES.palazzoDucale,
    date: "Luglio 2026",
    readTime: "7 min",
    content: [
      {
        type: "p",
        text: "Un weekend è il formato perfetto per Mantova: un giorno per la città e uno per il territorio. Soggiornando a Le dolci Dimore hai una base tranquilla a Borgo Virgilio, con il centro a circa dieci minuti e le strade della bassa che partono quasi dal cancello di casa.",
      },
      { type: "h2", text: "Sabato: la città dei Gonzaga" },
      {
        type: "p",
        text: "Dedica il primo giorno al centro storico. Mattina a Palazzo Ducale e alla Camera degli Sposi del Mantegna (prenota l'ingresso), pranzo in centro, pomeriggio tra Piazza delle Erbe, la Rotonda di San Lorenzo e la Basilica di Sant'Andrea. Se sei in vena di un secondo museo, scegli Palazzo Te: la Camera dei Giganti da sola vale la visita.",
      },
      { type: "h2", text: "Domenica: il Mincio e i borghi" },
      {
        type: "p",
        text: "Il secondo giorno esplora il paesaggio d'acqua del Parco del Mincio. Tra luglio e agosto la fioritura dei fiori di loto è uno spettacolo da non perdere, visibile anche dalle motonavi che partono da Mantova e da Grazie di Curtatone. In alternativa, noleggia una bicicletta e pedala un tratto della ciclabile Mantova–Peschiera, protetta e quasi tutta pianeggiante.",
      },
      { type: "h2", text: "Le tappe nei dintorni" },
      {
        type: "p",
        text: "Se preferisci i borghi all'acqua, Grazie di Curtatone con il suo santuario è a un quarto d'ora; Sabbioneta, la “città ideale” rinascimentale Patrimonio UNESCO, a poco più di mezz'ora. Sul percorso del ritorno, fermati per la cena in una trattoria della bassa: risotto alla pilota e salame mantovano sono la chiusura giusta del weekend.",
      },
      { type: "h2", text: "Dove dormire per un weekend a Mantova" },
      {
        type: "p",
        text: "Per un weekend serve una base semplice da raggiungere, comoda per l'auto e tranquilla la notte. Le dolci Dimore, in Strada Romana a Borgo Virgilio, unisce queste tre cose: quattro camere con bagno privato in una villa del Settecento, a pochi minuti dal casello di Mantova Sud e dal centro.",
      },
    ],
  },
  {
    slug: "natura-e-percorsi-lungo-il-mincio",
    title: "Natura e percorsi lungo il Mincio",
    excerpt:
      "Fiori di loto, ciclabili d'argine e navigazione fluviale: come vivere il Parco del Mincio partendo da Borgo Virgilio.",
    image: IMAGES.mincio,
    date: "Luglio 2026",
    readTime: "6 min",
    content: [
      {
        type: "p",
        text: "Il Mincio è il filo d'acqua che lega Mantova al Garda: prima forma i tre laghi che abbracciano la città, poi scorre lento verso sud tra argini e riserve. Il Parco del Mincio tutela questo paesaggio ed è una delle ragioni migliori per fermarsi più di una notte in zona.",
      },
      { type: "h2", text: "La fioritura dei fiori di loto" },
      {
        type: "p",
        text: "Tra luglio e agosto, le acque del Lago Superiore e del fiume si coprono di fiori di loto, una pianta arrivata dall'Asia un secolo fa e diventata il simbolo estivo di Mantova. I punti di osservazione più belli sono lungo le rive tra Mantova e Grazie di Curtatone: le motonavi del Parco permettono di attraversare le distese fiorite da vicino.",
      },
      { type: "h2", text: "La ciclabile Mantova – Peschiera" },
      {
        type: "p",
        text: "È una delle ciclabili fluviali più amate d'Italia: circa 45 chilometri quasi interamente in sede protetta, dal Lago Superiore di Mantova a Peschiera del Garda, costeggiando il fiume. Non serve percorrerla tutta: anche un tratto di pochi chilometri regala mulini, ponti e squarci sul fiume.",
      },
      { type: "h2", text: "A piedi, con calma" },
      {
        type: "p",
        text: "Chi preferisce camminare trova percorsi semplici sugli argini e nelle riserve del Parco, come la zona delle valli intorno a Grazie. Mattina presto e tardo pomeriggio sono i momenti con la luce migliore e più avifauna: aironi, cavalieri d'Italia e, con un po' di fortuna, il martin pescatore.",
      },
      { type: "h2", text: "Organizzare l'escursione" },
      {
        type: "p",
        text: "Da Le dolci Dimore gli accessi al Parco sono a circa un quarto d'ora in auto. Porta acqua e cappello d'estate, verifica orari e disponibilità delle motonavi sul sito del Parco del Mincio e, se vuoi pedalare, chiedici consiglio sul noleggio più vicino: ti indicheremo volentieri le opzioni aggiornate.",
      },
    ],
  },
  {
    slug: "cosa-mangiare-a-mantova",
    title: "Cosa mangiare a Mantova: guida alla cucina mantovana",
    excerpt:
      "Tortelli di zucca, risotto alla pilota, sbrisolona: i piatti da provare e la storia contadina e di corte che raccontano.",
    image: IMAGES.food,
    date: "Luglio 2026",
    readTime: "6 min",
    content: [
      {
        type: "p",
        text: "La cucina mantovana ha due anime: quella raffinata della corte dei Gonzaga e quella sostanziosa della campagna. Il risultato è una tavola ricca di piatti che non trovi altrove, e che da soli giustificano il viaggio.",
      },
      { type: "h2", text: "I primi: tortelli e risotto" },
      {
        type: "p",
        text: "Il tortello di zucca è il piatto simbolo: sfoglia ripiena di zucca, mostarda mantovana e amaretti, condito con burro e salvia. Il suo contraltare è il risotto alla pilota, nato tra i piloti che pilavano il riso nelle pile: riso Vialone Nano mantecato a puntel, cioè con la salamella.",
      },
      { type: "h2", text: "I salumi e i formaggi" },
      {
        type: "p",
        text: "Il salame mantovano è morbido, profumato d'aglio e vino, da tagliare al coltello a fette spesse. Con lui arrivano in tavola ciccioli, cotechino e il Grana Padano delle frazioni di pianura. L'agnoli in brodo è il piatto delle feste, ma d'inverno si trova spesso anche nei menu dei giorni feriali.",
      },
      { type: "h2", text: "I dolci: sbrisolona e anello di Monaco" },
      {
        type: "p",
        text: "La torta sbrisolona, dura e ricca di mandorle, non si taglia: si rompe con le mani, come vuole la tradizione. L'anello di Monaco è invece un dolce lievitato della tradizione svizzera-italiana, glassato e soffice, legato alla storia delle comunità di pasticceri immigrati.",
      },
      { type: "h2", text: "Dove assaggiare" },
      {
        type: "p",
        text: "Trattorie e ristoranti di cucina tradizionale si trovano sia nel centro di Mantova sia nella campagna di Borgo Virgilio e dintorni, spesso a pochi minuti dalla struttura. Al tuo arrivo ti segnaliamo volentieri gli indirizzi aggiornati in base alla stagione e ai giorni di apertura.",
      },
    ],
  },
];

export const FAQS = [
  {
    q: "Dove si trova Le dolci Dimore?",
    a: "In Strada Romana 69/A a Borgo Virgilio, in provincia di Mantova, immersa nella campagna mantovana e a pochi minuti dal casello autostradale A22 di Mantova Sud.",
  },
  {
    q: "Quanto dista dal centro di Mantova?",
    a: "Il centro storico di Mantova dista circa 6-8 km, indicativamente dieci minuti in auto. Le distanze esatte dipendono dal punto di arrivo in città.",
  },
  {
    q: "Quali tipologie di camera sono disponibili?",
    a: "Quattro camere, tutte con bagno privato: la 101 e la 104 Standard matrimoniali (fino a 2 ospiti), la 102 Superior con letto matrimoniale e divano letto singolo (fino a 3) e la 103 Deluxe con letto matrimoniale e divano letto matrimoniale (fino a 4).",
  },
  {
    q: "Quante persone possono soggiornare in ogni camera?",
    a: "Le Standard ospitano fino a 2 persone (anche in uso singolo), la Superior fino a 3, la Deluxe fino a 4.",
  },
  {
    q: "Le camere hanno un bagno privato?",
    a: "Sì, tutte e quattro le camere dispongono di bagno privato.",
  },
  {
    q: "A che ora si può effettuare il check-in?",
    a: "Il check-in è previsto dalle 15:00 alle 20:00. Se hai esigenze particolari di orario, contattaci in anticipo: valuteremo insieme la soluzione migliore.",
  },
  {
    q: "Entro che ora bisogna lasciare la camera?",
    a: "Il check-out è previsto entro le 10:00, per consentire il riordino delle camere, che avviene entro le 12:00.",
  },
  {
    q: "Come funziona l'accesso da remoto?",
    a: "Quando non è possibile accoglierti di persona, organizziamo l'accesso da remoto: ricevi le istruzioni prima dell'arrivo e restiamo disponibili telefonicamente per assisterti in ogni passaggio.",
  },
  {
    q: "Come viene organizzata la colazione?",
    a: "In autonomia, direttamente in camera: trovi croissant, fette biscottate, cereali, biscotti, miele, marmellate e Nutella, con bollitore e macchina per il caffè. Nel frigorifero sono disponibili acqua, succo e yogurt.",
  },
  {
    q: "Come posso prenotare direttamente?",
    a: "Tramite il pulsante “Prenota” presente in ogni pagina del sito, che porta al nostro booking engine ufficiale Beddy, dove puoi verificare disponibilità e tariffe aggiornate. In alternativa puoi chiamarci o scriverci.",
  },
  {
    q: "Come posso contattare la struttura?",
    a: "Per telefono al numero +39 0376 1587002, via email a info@ledolcidimore.it oppure compilando il modulo nella pagina Contatti.",
  },
  {
    q: "La struttura è adatta a chi viaggia per lavoro?",
    a: "Sì: la posizione vicino al casello A22 di Mantova Sud, la quiete della campagna e la colazione in autonomia in camera la rendono comoda per soggiorni di lavoro.",
  },
];

export const NAV_LINKS = [
  { to: "/la-struttura", label: "La struttura" },
  { to: "/camere", label: "Camere" },
  { to: "/servizi-e-informazioni", label: "Servizi" },
  { to: "/il-territorio", label: "Territorio" },
  { to: "/guida", label: "Guida" },
  { to: "/faq", label: "FAQ" },
  { to: "/contatti", label: "Contatti" },
];
